// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@bg/XDL/Utilities";
import { imageStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsImage";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

imageStyles.container = {
    gap: 5,
    css: css`
        margin: 15px;
        padding-bottom: 40px;
        border-bottom: 1px solid ${getColor("common.ui3")};
        ${xScreen("lte", "xs")} {
            max-width: 320px;
        }
    `,
};

imageStyles.productLinkItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
        text-align: left;
    `,
};

imageStyles.imageMissingText = {
    variant: "h1",
    css: css`
        width: 100%;
        overflow-wrap: break-word;
        word-wrap: break-word;
    `,
};

imageStyles.externalLinkItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
        text-align: left;
    `,
};
